import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { ChevronRightIcon, HatIcon } from "../svgcomponents/common-icons";
import styles from "./breadcrumb.module.scss";

const Breadcrumb = ({ isLearningPath = true, lpname, breadcrumbTitle }) => {
  const router = useRouter();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    if (router) {
      const pathWithoutQuery = router?.asPath?.split("?")[0];
      const linkPath = pathWithoutQuery.split("/");
      linkPath.shift();

      // Always set first item as Learning Path
      const pathArray = [
        {
          breadcrumb: "Learning Path",
          href: "/learning-paths",
        },
      ];

      // Add the second item (current page)
      if (linkPath.length >= 2) {
        const currentPath = linkPath.slice(0, 2).join("/");
        pathArray.push({
          breadcrumb: linkPath[1].replace(/-/g, " ").replace(/\[|\]/g, ""),
          href: "/" + currentPath,
        });
      }

      setBreadcrumbs(pathArray);
    }
  }, [router]);

  if (!breadcrumbs?.length) {
    return null;
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className={`${isLearningPath && styles["border-b-gray"]}`}
      role="navigation"
    >
      <div className="mw-1920">
        <ol
          className={styles.breadcrumb}
          itemScope
          itemType="https://schema.org/BreadcrumbList"
        >
          {breadcrumbs.map((breadcrumb, i) => {
            const position = i + 1;
            const isLast = i === breadcrumbs.length - 1;
            const extractedPath = breadcrumb?.href?.replace(
              "/learning-paths",
              ""
            );
            const isSameLp =
              isLast && extractedPath?.toLowerCase() === lpname?.toLowerCase();

            return (
              <li
                key={breadcrumb.href}
                className={`${styles["breadcrumb-item"]} ${isSameLp ? styles.disabled : ""}`}
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <a
                  href={isSameLp ? "#" : `/academy${breadcrumb.href}`}
                  className={`text-decoration-none justify-content-start text-capitalize underline-focussed d-flex align-items-center ${isSameLp ? styles.disabled : ""}`}
                  aria-label={`Go to ${i === 0 ? "Learning Path" : breadcrumbTitle || breadcrumb.breadcrumb} page`}
                  itemProp="item"
                  {...(isSameLp && { "aria-disabled": "true" })}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <HatIcon />
                  </div>
                  <span
                    itemProp="name"
                    className="p-0"
                  >
                    {i === 0
                      ? "Learning Path"
                      : breadcrumbTitle || breadcrumb.breadcrumb}
                  </span>
                  {!isLast && <ChevronRightIcon />}
                </a>
                <meta
                  itemProp="position"
                  content={position}
                />
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
